import { JsonObject, JsonProperty } from 'json2typescript';
import { Required } from '@hvlng/framework-bff/core';
import { HvlDateConverter } from '@hvlng/framework-bff/util';
import { CodeTextDiscriminatorQueryModel } from './code-text-discriminator-query-model';

@JsonObject('KovanHrPayrollCodeTextQueryModel')
export class PayrollCodeTextQueryModel extends CodeTextDiscriminatorQueryModel {
    @Required()
    @JsonProperty('beginDate', HvlDateConverter, true)
    beginDate: Date = null;

    @Required()
    @JsonProperty('endDate', HvlDateConverter, true)
    endDate: Date = null;
}
